export const notifications = [
    { id: 1, name: 'Jeremy Solosa', message: 'responded to your review.', time: '1 hour ago' },
    { id: 2, name: 'Scott James', message: 'responded to your review.', time: '4 hours ago' },
    { id: 3, name: 'Steffani Putri', message: 'responded to your review.', time: '1 day ago' },
    { id: 4, name: 'Kirana Larasati', message: 'responded to your review.', time: '1 week ago' },
  ];